<div (touchmove)="onContainerTouchMove($event)">
	<!-- Alle Layer (normale + Zeichnungslayer + interne Layer) -->
	<div class="list-group list-group-flush list-group-scrollable">
		<ng-container *ngFor="let item of items">
			<ng-container *ngIf="item.isGridLayer; else checkInternal">
				<ng-container *ngTemplateOutlet="gridItem; context: { $implicit: item }"></ng-container>
			</ng-container>
			<ng-template #checkInternal>
				<ng-container *ngIf="item.isInternalLayer; else checkZeichnung">
					<ng-container *ngTemplateOutlet="internalItem; context: { $implicit: item }"></ng-container>
				</ng-container>
				<ng-template #checkZeichnung>
					<ng-container *ngIf="item.isZeichnungslayer; else normalLayer">
						<ng-container *ngTemplateOutlet="zeichnungItem; context: { $implicit: item }"></ng-container>
					</ng-container>
					<ng-template #normalLayer>
						<ng-container *ngTemplateOutlet="listItem; context: { $implicit: item, canDelete: true }"></ng-container>
					</ng-template>
				</ng-template>
			</ng-template>
		</ng-container>
	</div>

</div>

<ng-template #listItem let-item>
	<div [attr.data-item-id]="item.id"
		[class]="'list-group-item d-flex align-items-center gap-1 ' + (draggedItem?.id === item.id && isDragging ? 'dragging' : '')"
		(dragover)="onDragOver($event)"
		(dragenter)="onDragEnter($event, item)"
		(drop)="onDrop($event, item)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		style="user-select: none;">

		<i class="bi bi-grip-vertical fs-5 text-secondary cursor-move" data-gripper draggable="true"
			style="touch-action: none;"
			(dragstart)="onDragStart($event, item)"
			(dragend)="onDragEnd($event)"
			(touchstart)="onTouchStart($event, item)"></i>
		<!-- Sichtbarkeits-Toggle (Auge) - immer nach Gripper -->
		<button class="btn btn-sm btn-outline-dark" type="button" (click)="toggleVisibility(item)"
			[title]="isZoomHidden(item) ? 'Ausgeblendet bei aktuellem Zoom' : ''">
			<i class="bi" [ngClass]="{'bi-eye': item.visible && !isZoomHidden(item), 'bi-eye-slash': !item.visible || isZoomHidden(item)}"></i>
		</button>
		<span *ngIf="renamingItemId() !== item.id" class="flex-grow-1 truncate-multiline" (dblclick)="startRename(item)">{{ item.ld?.displayName || item.text }}</span>
		<input *ngIf="renamingItemId() === item.id" class="form-control form-control-sm flex-grow-1 rename-input"
			   [value]="item.ld?.displayName || item.text"
			   (blur)="finishRename(item, $any($event.target).value)"
			   (keydown.enter)="$any($event.target).blur()"
			   (keydown.escape)="cancelRename(); $any($event.target).blur()">

		<!-- Für GPKG-Sublayer: Grüner Haken oder roter Fehler-Indikator -->
		<ng-container *ngIf="item.gpkgSubLayer && statusInitialized()">
			<button *ngIf="isGeodataPresent(item)"
					class="btn btn-sm btn-outline-success" type="button" disabled>
				<i class="bi bi-check-lg"></i>
			</button>
			<button *ngIf="!isGeodataPresent(item)"
					class="btn btn-sm btn-outline-danger" type="button"
					(click)="restoreMissingGeodata(item)"
					title="Datei fehlt - klicken zum Wiederherstellen">
				<i class="bi bi-folder-x"></i>
			</button>
		</ng-container>

		<!-- Style-Button für GPKG-Sublayer -->
		<span *ngIf="item.gpkgSubLayer" class="color-indicator clickable"
			  [style.background-color]="getGpkgFillColor(item)"
			  [style.border-color]="getGpkgStrokeColor(item)"
			  (click)="openGpkgStyleModal(item)"
			  title="Stil ändern"></span>

		<!-- Für Geodaten-Dateien (nicht GPKG-Sublayer): Grüner Haken -->
		<ng-container *ngIf="item.isGeodata && !item.gpkgSubLayer">
			<ng-container *ngIf="statusInitialized()">
				<button *ngIf="isGeodataPresent(item)"
						class="btn btn-sm btn-outline-success" type="button" disabled>
					<i class="bi bi-check-lg"></i>
				</button>
				<button *ngIf="!isGeodataPresent(item)"
						class="btn btn-sm btn-outline-danger" type="button"
						(click)="restoreMissingGeodata(item)"
						title="Datei fehlt - klicken zum Wiederherstellen">
					<i class="bi bi-folder-x"></i>
				</button>
			</ng-container>
			<!-- Style-Button für GeoJSON-Layer -->
			<span *ngIf="item.ld.type === 'geojson'" class="color-indicator clickable"
				  [style.background-color]="getGeojsonFillColor(item)"
				  [style.border-color]="getGeojsonStrokeColor(item)"
				  (click)="openGeojsonStyleModal(item)"
				  title="Stil ändern"></span>
		</ng-container>

		<!-- DGM-Kalibrierung (Berg-Icon) -->
		<ng-container *ngIf="isDgmLayer(item)">
			<button *ngIf="!dgmCalibration.settings()" class="btn btn-sm btn-outline-dark" type="button"
					(click)="calibrateDgm()" title="Höhenfarben kalibrieren"
					[disabled]="oms.offlineMode()">
				<i class="bi bi-palette"></i>
			</button>
			<button *ngIf="dgmCalibration.settings()" class="btn btn-sm btn-outline-success" type="button"
					(click)="resetDgmCalibration()" title="Kalibrierung zurücksetzen ({{dgmCalibration.settings()!.min}}m – {{dgmCalibration.settings()!.max}}m)">
				<i class="bi bi-palette-fill"></i>
			</button>
		</ng-container>

		<!-- Für Tile-Layer (WMS, OSM): Download-Status -->
		<ng-container *ngIf="!item.isGeodata && !item.noDownloadStatus && !item.gpkgSubLayer">
			<button *ngIf="statusInitialized()" class="btn btn-sm btn-outline-dark" type="button" (click)="downloadLayer(item)"
				[disabled]="isSeeding(item) || getDownloadStatus(item) === 'complete' || oms.offlineMode()">
				<i class="bi"
					[class.bi-cloud]="getDownloadStatus(item) === 'none'"
					[class.bi-cloud-download-fill]="getDownloadStatus(item) === 'partial'"
					[class.bi-cloud-check]="getDownloadStatus(item) === 'complete'"
					[class.text-danger]="getDownloadStatus(item) === 'partial'"
					[class.text-success]="getDownloadStatus(item) === 'complete'"></i>
			</button>
			<!-- Spacer für Style-Icon-Spalte (damit Lupe ausgerichtet ist) -->
			<span class="color-indicator-spacer"></span>
		</ng-container>

		<!-- Zoom-Button (ganz rechts) -->
		<button *ngIf="hasBounds(item)"
				class="btn btn-sm btn-outline-dark" type="button"
				(click)="zoomToLayer(item)"
				title="Auf Layer zoomen">
			<i class="bi bi-search"></i>
		</button>
	</div>
</ng-template>

<!-- Template für Zeichnungslayer -->
<ng-template #zeichnungItem let-item>
	<div [attr.data-item-id]="item.id"
		[class]="'list-group-item d-flex align-items-center gap-1 ' + (draggedItem?.id === item.id && isDragging ? 'dragging' : '') + (isEditing(item.zeichnungslayerId) ? ' zeichnung-active' : '') + (isLastActive(item.zeichnungslayerId) ? ' zeichnung-last-active' : '')"
		(dragover)="onDragOver($event)"
		(dragenter)="onDragEnter($event, item)"
		(drop)="onDrop($event, item)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		style="user-select: none;">

		<!-- Gripper für Drag & Drop -->
		<i class="bi bi-grip-vertical fs-5 text-secondary cursor-move" data-gripper draggable="true"
			style="touch-action: none;"
			(dragstart)="onDragStart($event, item)"
			(dragend)="onDragEnd($event)"
			(touchstart)="onTouchStart($event, item)"></i>

		<!-- Sichtbarkeits-Toggle -->
		<button class="btn btn-sm btn-outline-dark" type="button"
				(click)="toggleZeichnungslayerVisibility(item.zeichnungslayerId)">
			<i class="bi" [ngClass]="{'bi-eye': item.visible, 'bi-eye-slash': !item.visible}"></i>
		</button>

		<!-- Name -->
		<span *ngIf="renamingItemId() !== item.id" class="flex-grow-1 truncate-multiline" (dblclick)="startRename(item)">{{ item.text }}</span>
		<input *ngIf="renamingItemId() === item.id" class="form-control form-control-sm flex-grow-1 rename-input"
			   [value]="item.text"
			   (blur)="finishRename(item, $any($event.target).value)"
			   (keydown.enter)="$any($event.target).blur()"
			   (keydown.escape)="cancelRename(); $any($event.target).blur()">

		<!-- Bearbeitungsmodus-Toggle (QGIS-Style) - für Gäste deaktiviert -->
		<button class="btn btn-sm btn-edit-layer" type="button"
				[ngClass]="isEditing(item.zeichnungslayerId) ? 'btn-warning' : (isLastActive(item.zeichnungslayerId) ? 'btn-outline-warning' : 'btn-outline-secondary')"
				[disabled]="isGuest()"
				(click)="!isGuest() && toggleEdit(item.zeichnungslayerId)"
				[title]="isGuest() ? guestHint : (isLastActive(item.zeichnungslayerId) ? 'Zuletzt verwendet – wird bei Zeichentool-Aktivierung automatisch ausgewählt' : 'Bearbeitungsmodus umschalten')">
			<i class="bi bi-pencil"></i>
		</button>

		<!-- Farbindikator (öffnet Stil-Dialog) - für Gäste deaktiviert -->
		<span class="color-indicator"
			  [class.clickable]="!isGuest()"
			  [style.background-color]="getDrawFillColor(item)"
			  [style.border-color]="getDrawStrokeColor(item)"
			  (click)="!isGuest() && openStyleModal(item)"
			  [title]="isGuest() ? '' : 'Zeichenstil ändern'"></span>

		<!-- Zoom-Button -->
		<button class="btn btn-sm btn-outline-dark"
				(click)="zoomToZeichnungslayer(item.zeichnungslayerId)"
				title="Auf Layer zoomen">
			<i class="bi bi-search"></i>
		</button>
	</div>
</ng-template>

<!-- Template für interne Layer (Punkte) -->
<ng-template #internalItem let-item>
	<div [attr.data-item-id]="item.id"
		[class]="'list-group-item d-flex align-items-center gap-1 ' + (draggedItem?.id === item.id && isDragging ? 'dragging' : '')"
		(dragover)="onDragOver($event)"
		(dragenter)="onDragEnter($event, item)"
		(drop)="onDrop($event, item)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		style="user-select: none;">

		<!-- Gripper für Drag & Drop -->
		<i class="bi bi-grip-vertical fs-5 text-secondary cursor-move" data-gripper draggable="true"
			style="touch-action: none;"
			(dragstart)="onDragStart($event, item)"
			(dragend)="onDragEnd($event)"
			(touchstart)="onTouchStart($event, item)"></i>

		<!-- Sichtbarkeits-Toggle -->
		<button class="btn btn-sm btn-outline-dark" type="button"
				[disabled]="item.internalLayerId === '__polygons__'"
				(click)="toggleInternalLayerVisibility(item.internalLayerId)">
			<i class="bi" [ngClass]="{'bi-eye': item.visible, 'bi-eye-slash': !item.visible}"></i>
		</button>

		<!-- Name -->
		<span class="truncate-multiline"
			[style.text-decoration]="item.internalLayerId === '__polygons__' ? 'line-through' : 'none'"
			[style.opacity]="item.internalLayerId === '__polygons__' ? '0.5' : '1'">{{ item.text }}</span>

		<!-- Info-Button für Punkte-Legende -->
		<i *ngIf="item.internalLayerId === '__points__'"
			class="bi bi-info-circle ms-1 text-secondary legend-info-icon"
			(click)="openLegendModal()"
			title="Symbol-Legende anzeigen"></i>

		<!-- Spacer für Ausrichtung -->
		<span class="flex-grow-1"></span>
	</div>
</ng-template>

<!-- Template für Grid-Layer (Punktraster) -->
<ng-template #gridItem let-item>
	<div [attr.data-item-id]="item.id"
		[class]="'list-group-item d-flex align-items-center gap-1 ' + (draggedItem?.id === item.id && isDragging ? 'dragging' : '')"
		(dragover)="onDragOver($event)"
		(dragenter)="onDragEnter($event, item)"
		(drop)="onDrop($event, item)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		style="user-select: none;">

		<!-- Gripper für Drag & Drop -->
		<i class="bi bi-grip-vertical fs-5 text-secondary cursor-move" data-gripper draggable="true"
			style="touch-action: none;"
			(dragstart)="onDragStart($event, item)"
			(dragend)="onDragEnd($event)"
			(touchstart)="onTouchStart($event, item)"></i>

		<!-- Sichtbarkeits-Toggle -->
		<button class="btn btn-sm btn-outline-dark" type="button"
				(click)="toggleVisibility(item)">
			<i class="bi" [ngClass]="{'bi-eye': item.visible, 'bi-eye-slash': !item.visible}"></i>
		</button>

		<!-- Name -->
		<span *ngIf="renamingItemId() !== item.id" class="flex-grow-1 truncate-multiline" (dblclick)="startRename(item)">{{ item.ld?.displayName || item.text }}</span>
		<input *ngIf="renamingItemId() === item.id" class="form-control form-control-sm flex-grow-1 rename-input"
			   [value]="item.ld?.displayName || item.text"
			   (blur)="finishRename(item, $any($event.target).value)"
			   (keydown.enter)="$any($event.target).blur()"
			   (keydown.escape)="cancelRename(); $any($event.target).blur()">

		<!-- Grid-Controls (kompakter Modus) -->
		<bp-grid-controls
			[compact]="true"
			[gridStyle]="item.gridStyle"
			[gridRadius]="item.gridStyle?.radius ?? 3"
			[gridResolution]="item.gridResolution ?? 5"
			(styleChange)="onGridStyleChange(item, $event)"
			(resolutionChange)="onGridResolutionChange(item, $event)"
			(radiusChange)="onGridRadiusChange(item, $event)">
		</bp-grid-controls>

		<!-- Zoom-Button für Grid -->
		<button class="btn btn-sm btn-outline-dark" type="button"
				(click)="zoomToGrid()"
				title="Auf Punktraster zoomen">
			<i class="bi bi-search"></i>
		</button>
	</div>
</ng-template>
